import { defineComponent, h } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import { getComponent, getContextModules } from "@/lib/requireContextHelpers";

const modules = getContextModules<Message>(require.context("./", true, /\.\/[a-zA-Z]*\/index.ts/));

export default function(item: Message) {
  return getComponent(
    modules,
    item,
    defineComponent({
      setup: () => () => h(),
    })
  );
}
